exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".masonry-column[data-v-6024a280]{display:inline-block;vertical-align:top}.item[data-v-6024a280]{margin-bottom:16px !important}.name[data-v-6024a280]{font-size:18px}.masonry-footer[data-v-6024a280]{color:#5f6265;font-size:14px;display:flex;justify-content:space-between;align-items:center;padding-top:16px}\n", ""]);

